import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var CaretRight = function (props) { return (React.createElement(Icon, __assign({ width: '20px', height: '20px', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, props),
    React.createElement("path", { d: 'M7.5 3.75L13.75 10L7.5 16.25', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }))); };

export { CaretRight as default };
//# sourceMappingURL=CaretRight.js.map
